module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAoCAMAAABevo0zAAAAPFBMVEUAAGYzAE0XElzywQXYPz/yv7//zADMAAD////lf39NPUbBmhh1XTbTqBE5LU8qIlWTdiphTj5/ZTOqiCG9Hr0CAAABDUlEQVRIx9WVzW7EIAyEXXt3tmtM+Mn7v2tPASJFFSFslc6Ji0c232CIOvXqFH3ccOFjw0en9lW6CvxqR57fndrZCXxiIppkGIG4nQOFQKE1fHaqVqTGjzKpUr4EhQV+OyppNotKyuOGBmgh7RZxTha31A7fnSoFK2RrkEkhgECJeRhKnZiS9wIA4l0apsyAq/NlAABaKqdHrh0Gc6XDmvHTUFy5Q6J6hxdiE4H0G+XTwQ6AcMlhMrOc2hyef3rWYjFSJbv+lv3WEVMI+x0xsr4MwKp8vG2GFmzIDhAf+S++gJEFO8fwq1PdOXxN1nzDx2R1X3Y3lOmG78n6B5Snj3x/ytODfX/Kz8m6P+UfevBF/xzUcWoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/flags/my.png
// module id = eFcs
// module chunks = 2